import { CREDIT_ACTIONS } from '../../Action/CreditAction/CreditAction';

const initialState = {
  parties: [],
  loans: [],
  summary: null,
  loading: false,
  actionLoading: false,
};

const CreditReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREDIT_ACTIONS.FETCH_PARTIES_START:
      return { ...state, loading: true };
    case CREDIT_ACTIONS.FETCH_PARTIES_SUCCESS:
      return { ...state, loading: false, parties: action.payload };
    case CREDIT_ACTIONS.FETCH_PARTIES_FAIL:
      return { ...state, loading: false };

    case CREDIT_ACTIONS.FETCH_LOANS_START:
      return { ...state, loading: true };
    case CREDIT_ACTIONS.FETCH_LOANS_SUCCESS:
      return { ...state, loading: false, loans: action.payload };
    case CREDIT_ACTIONS.FETCH_LOANS_FAIL:
      return { ...state, loading: false };

    case CREDIT_ACTIONS.SET_SUMMARY:
      return { ...state, summary: action.payload };

    case CREDIT_ACTIONS.ACTION_START:
      return { ...state, actionLoading: true };
    case CREDIT_ACTIONS.ACTION_END:
      return { ...state, actionLoading: false };

    default:
      return state;
  }
};

export default CreditReducer;